import { useEffect, RefObject } from 'react'

const isClient = typeof document !== undefined

export default function useClickOutside(domRef: RefObject<HTMLElement>, callback?: Function, conditionCallback?: Function) {
  useEffect(() => {
    function handleClick(evt: MouseEvent) {
      // evt.preventDefault()
      const target = evt.target as Node
      if (domRef && domRef.current && !domRef.current.contains(target)) {
        if (conditionCallback)
          conditionCallback(target)
        else
          callback && callback()
      }

    }
    if (isClient) {
      document.addEventListener('mousedown', handleClick, false)
    }
    return () => {
      if (isClient) {
        document.removeEventListener('mousedown', handleClick, false)
      }
    }
  }, [domRef])
}
